import usePhoneState from '@modules/SoftPhoneModule/usePhoneState';
import { CallBar } from '../CallBar/CallBar';
import { CallState } from '@modules/SoftPhoneModule/types';
import useInboxState from '@modules/InboxModule/hooks/useInboxState';

const CallBarManager = () => {
  const { callList } = usePhoneState();
  const { selectedTaskId } = useInboxState();

  const allCallsHeld = Object.values(callList).every((call) => call.held);

  return Object.values(callList).map((call) => {
    const callState: CallState = {
      ...call,
      queueIds: [...call.queueIds],
    };

    // if all calls are held, show the call bar for selected task
    const showSelectedCallBar =
      allCallsHeld &&
      !!selectedTaskId &&
      selectedTaskId === call.pcsConversationSid;

    return (
      <CallBar
        key={call.callId}
        callState={callState}
        show={!call.held || showSelectedCallBar}
      />
    );
  });
};

export default CallBarManager;
